<template>
    <div class="mobile-main-layout">
        <main class="mobile-content" :class="{ 'no-tabbar': shouldHideTabbar }">
            <router-view></router-view>
        </main>
        <nav v-if="!shouldHideTabbar" class="mobile-tabbar">
            <button
                v-for="tab in tabs"
                :key="tab.route"
                :class="['tab-btn', { active: currentTab === tab.route }]"
                @click="goTab(tab.route)"
            >
                <i :class="tab.icon" class="tab-icon"></i>
                <span>{{ tab.label }}</span>
            </button>
        </nav>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const tabs = [
    { label: "首页", route: "/m/main", icon: "fas fa-home" },
    { label: "报告", route: "/m/report", icon: "fas fa-file-medical" },
    { label: "解忧", route: "/m/ai", icon: "fas fa-lightbulb" },
    { label: "更多", route: "/m/more", icon: "fas fa-cubes" },
];
const currentTab = computed(() => route.path);

// 需要隐藏底部导航栏的页面路径
const hideTabbarPaths = [
    '/m/depression-assessment',
    '/m/assessment-detail',
    '/m/assessment-quiz',
    '/m/assessment-result',
    '/m/treatment-flow'
];

// 判断是否应该隐藏底部导航栏
const shouldHideTabbar = computed(() => {
    return hideTabbarPaths.some(path => route.path.includes(path));
});

function goTab(path) {
    if (path !== route.path) {
        router.push(path);
    }
}
</script>

<style scoped>
.mobile-main-layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #f8f8fc;
    /* 安全区域适配 - 顶部 */
    padding-top: env(safe-area-inset-top, 0);
}

.mobile-content {
    flex: 1;
    padding-bottom: 56px;
    box-sizing: border-box;
    /* 安全区域适配 - 底部（如果有底部导航） */
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0));
}

.mobile-content.no-tabbar {
    padding-bottom: 0;
}
.mobile-tabbar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: calc(56px + env(safe-area-inset-bottom, 0));
    padding-bottom: env(safe-area-inset-bottom, 0);
    background: #fff;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    padding-top: 8px;
    z-index: 100;
}
.tab-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    color: #888;
    font-size: 13px;
    padding: 0;
    cursor: pointer;
    transition: color 0.2s;
}
.tab-btn.active {
    color: var(--primary-color, #7035e6);
}
.tab-icon {
    font-size: 22px;
    margin-bottom: 2px;
}
</style>
